<template>
    <!-- Not inside the AI generator's preview: that page carries the UXfolio logo of its
         own, and the portfolio shown there is not anyone's published page yet. -->
    <div v-if="!inGenerationPreview" class="footer-share">
        <div class="grid">
            <div class="footer-share-content" :class="portfolio.templateSettings.theme !== 'profile_theme_nine' ? 'show-color-background' : ''">
                <a href="https://uxfol.io/?utm_campaign=branding_header" rel="nofollow" class="ufo--branding floating">
                    Made with <UXFolioLogo />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import UXFolioLogo from "@/scripts/view/components/UXFolioLogo.vue";
    import {mapGetters} from "vuex";
    import {isPortfolioGenerationPreviewRoute} from "@/scripts/view/portfolio/generationPreview.js";

    export default {
        name: "UXfolioBranding",
        components: {
            UXFolioLogo
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            portfolio() {
                return this.viewData.portfolio
            },
            inGenerationPreview() {
                return isPortfolioGenerationPreviewRoute(this.$route);
            },
        }
    }
</script>